module.exports = __webpack_public_path__ + "static/3BHK-06-Bedroom-02-e869b2d41392574a76705f1655693305.jpg";